import { StyleSheet, Text, View } from "@react-pdf/renderer";
import React, { Fragment } from "react";

const styles = StyleSheet.create({
  mainContainer: {
    marginTop: 6,
    width: "98%",
  },
  invoiceNoContainer: {
    flexDirection: "row",
    // display: 'flex',
  },
  rowContainer: {
    flexDirection: "row-reverse",
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },
  invoiceText: {
    color: "black",
    fontWeight: "bold",
    fontSize: "15.5px",
    marginLeft: "4",
  },
  label1: {
    width: "60%",
    // textAlign: "right",
  },
  label2: {
    width: "9%",
    // textAlign: "right",
  },
});

const InvoiceNo = ({ invoice }) => {
const status="production";
const preparedBy = (invoice.payment < 0 && status === "dispatched")
  ? invoice?.user
  : (invoice.payment > 0)
    ? invoice.username
    : invoice?.items[0]?.name;

return(
<Fragment>
    <View style={styles.mainContainer}>
      <View style={styles.rowContainer}>
        <View style={styles.invoiceNoContainer}>
          <Text
            style={{ ...styles.invoiceText, fontFamily: "NotoNastaliqUrdu" }}
          >
            {/* {invoice?.invoice_no} */}
          </Text>
          <Text
            style={{ ...styles.invoiceText, fontFamily: "NotoNastaliqUrdu" }}
          >
            : انوائس نمبر
          </Text>
        </View>
        <View style={styles.invoiceNoContainer}>
          <Text
            style={{ ...styles.invoiceText, fontFamily: "NotoNastaliqUrdu" }}
          >
            {invoice.date}
          </Text>
          <Text
            style={{ ...styles.invoiceText, fontFamily: "NotoNastaliqUrdu" }}
          >
            : تاریخ
          </Text>
        </View>
      </View>
      <View style={{...styles.rowContainer,marginTop:7}}>
        <View style={styles.invoiceNoContainer}>
          <Text
            style={{ ...styles.invoiceText, fontFamily: "NotoNastaliqUrdu" }}
          >
              {invoice.name_urdu}
          </Text>
          <Text
            style={{ ...styles.invoiceText, fontFamily: "NotoNastaliqUrdu" }}
          >
          : گاہک کا نام
          </Text>
        </View>
        
        <View style={styles.invoiceNoContainer}>
          <Text
            style={{ ...styles.invoiceText, fontFamily: "NotoNastaliqUrdu" }}
          >
              {preparedBy}
          </Text>
          {invoice.payment > 0 ? (
          <Text style={{ ...styles.invoiceText, fontFamily: "NotoNastaliqUrdu" }}>
            :ڈیلیور کنندہ
            </Text>
              ) : (
            <Text style={{ ...styles.invoiceText, fontFamily: "NotoNastaliqUrdu" }}>
            :تیار کنندہ
              </Text>
                )}

        </View>
 
        <View style={styles.invoiceNoContainer}>
          <Text
            style={{ ...styles.invoiceText, fontFamily: "NotoNastaliqUrdu" }}
          >
          {invoice.address_urdu}
          </Text>
          <Text
            style={{ ...styles.invoiceText, fontFamily: "NotoNastaliqUrdu" }}
          >
            : پتہ
          </Text>
        </View>
      </View>
    </View>
  </Fragment>
)
  
};

export default InvoiceNo;
